import React, { useEffect, useState } from 'react'
import { FormWrapper, Label, Select, Button, Input } from './shared_form_styles';
import { useQuery, useMutation, gql } from '@apollo/client';
import { useDispatch, useSelector } from "react-redux";
import { updateEnrollment } from '../actions/enrollmentActions';
import { setSubjectInstances } from '../actions/subjectInstanceActions';


export const GradeOnEnrollment = ({ closePopup, subjectInstanceId, studentId }) => {

    const subjectInstanceSelected = useSelector((state) =>
        state.selection.selectedSubjectInstance ? state.selection.selectedSubjectInstance : null);
    const studentSelected = useSelector((state) =>
        state.selection.selectedStudent ? state.selection.selectedStudent : null);
    const enrollmentsArray = useSelector((state) =>
        state.enrollments ? state.enrollments : null);

    const [selectedStudent, setSelectedStudent] = useState("");
    const [selectedSubjectInstance, setSelectedSubjectInstance] = useState("");
    const [grade, setGrade] = useState("");
    const [status, setStatus] = useState("");

    const dispatch = useDispatch();

    useEffect(() => {
        let stselect;
        let subjinselect;
        if (studentSelected && subjectInstanceSelected) {
            stselect = studentSelected;
            subjinselect = subjectInstanceSelected;
        } else {
            if (subjectInstanceSelected) {
                subjinselect = subjectInstanceSelected;
                stselect = enrollmentsArray.find(enrollment => enrollment.subjectInstance._id === subjectInstanceSelected._id)?.student;
            } else {
                if (studentSelected) {
                    subjinselect = enrollmentsArray.find(enrollment => enrollment.student._id === studentSelected._id)?.subjectInstance;
                    stselect = studentSelected;
                } else {
                    subjinselect = enrollmentsArray[0].subjectInstance;
                    stselect = enrollmentsArray[0].student;
                }
            }
        }
        const enrollment = enrollmentsArray.find(en => en.subjectInstance._id == subjinselect._id && en.student._id == stselect._id)
        if (enrollment) {
            setGrade(enrollment.grade ? enrollment.grade : 0);
            setStatus(enrollment.status ? enrollment.status : '');
        }
        setSelectedStudent(stselect);
        setSelectedSubjectInstance(subjinselect);
    }, []);

    const handleSave = async () => {
        if (!selectedSubjectInstance._id || !selectedStudent._id) {
            console.error('no subject or student selected');
            return
        }
        const enrollment = enrollmentsArray.find(en => en.subjectInstance._id === selectedSubjectInstance._id && en.student._id === selectedStudent._id);
        if (!enrollment) {
            console.error('No enrollment for the selected subject and student');
            return;
        }
        let input = {
            enrollmentId: enrollment._id,
        };
     
        if ((status!="dropped" )&&  grade==0) {
         
            input = { ...input, status:"enrolled" , grade:null }
        } else {
            if (status == 'dropped') {
                input = { ...input, status, grade: grade ? parseFloat(grade) : 0 }
            } else {
                input = { ...input, status: "completed", grade: parseFloat(grade) }
            }
        }
        dispatch(updateEnrollment(input));
    };
    const handleStudentChange = (e) => {
        const selectedStudentId = e.target.value;
        const enrollment = enrollmentsArray.find(en => en.student._id === selectedStudentId && en.subjectInstance._id == selectedSubjectInstance._id);
        const student = enrollment?.student;
        setSelectedStudent(student);
        if (enrollment) {
            setGrade(enrollment.grade ? enrollment.grade : 0);
            setStatus(enrollment.status ? enrollment.status : '');
        }

    };

    const handleSubjectInstanceChange = (e) => {
        const selectedSubjectId = e.target.value;
        const enrollment = enrollmentsArray.find(en => en.student._id === selectedStudent._id && en.subjectInstance._id === selectedSubjectId);
        const subject = enrollment?.subjectInstance;
        setSelectedSubjectInstance(subject);
        if (enrollment) {
            setGrade(enrollment.grade ? enrollment.grade : 0);
            setStatus(enrollment.status ? enrollment.status : '');
        }
    };


    return (
        <FormWrapper>
            <Label>
                Student:
                <Select
                    value={selectedStudent?._id}
                    onChange={(e) => { handleStudentChange(e) }}
                >
                    {enrollmentsArray && selectedSubjectInstance && enrollmentsArray
                        .filter((enrollment) => enrollment.subjectInstance._id === selectedSubjectInstance?._id)
                        .map((item, index) => (
                            <option key={index} value={item.student._id}>{item.student.name}</option>
                        ))}
                </Select>
            </Label>
            <Label>
                Subject:
                <Select
                    value={selectedSubjectInstance?._id}
                    onChange={(e) => { handleSubjectInstanceChange(e) }}
                >
                    {enrollmentsArray && enrollmentsArray
                        .filter((enrollment) => enrollment.student._id === selectedStudent?._id)
                        .map((item, index) => (
                            <option key={index} value={item.subjectInstance._id}>{item.subjectInstance.subject.name}</option>
                        ))}
                </Select>
            </Label>

            <Label style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                Quit:
                <Input
                    style={{ width: '20px' }}
                    type="checkbox"
                    name="droppingOff"
                    checked={status === 'dropped'}
                    onChange={(e) => { setStatus(prevStatus => (prevStatus === 'dropped' ? '' : 'dropped')); }}
                />
            </Label>
            <Label>
                Grade:
                <Input
                    type="text"
                    name="grade"
                    value={grade}
                    placeholder='0'
                    onChange={(e) => { setGrade(e.target.value) }}
                />
            </Label>
            <Button onClick={() => { handleSave() }}>Save</Button>
        </FormWrapper>
    );
};


export default GradeOnEnrollment;
